import { useMemo } from 'react';
import { useUserInfo } from './useUserInfo';
export const useIsUngatedFor = gate => {
  const {
    isUngatedFor
  } = useUserInfo();
  return useMemo(() => isUngatedFor(gate), [isUngatedFor, gate]);
};